import moment from 'moment';
import React from 'react';

import {
  formatarMilhar,
  formatarMoedaIMask,
} from '../../../../../helpers/formatador';
import colors from '../../../../../styles/colors';
import DirecionamentoEnum from '../../../Enum/DirecionamentoEnum';
import TipoDirecionamentoEnum from '../../../Enum/TipoDirecionamentoEnum';
import { SubTitle } from './Modal/styles';
import {
  ActionButton,
  ContainerButtons,
  DeleteOutlined,
  DirecionamentoWrapper,
  FormOutlined,
  Tag,
} from './styles';

const validaTransportadoraTmov = record => {
  if (
    record.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE ||
    record.idTransportadora === 1
  ) {
    return false;
  }

  if (!record.idLote) {
    return true;
  }
};

const handleActions = (record, handleEditarLote, handleDeletarLote, index) => {
  const content = (
    <>
      <ActionButton type="link" onClick={() => handleEditarLote(record, index)}>
        <FormOutlined />
      </ActionButton>

      {validaTransportadoraTmov(record) && (
        <ActionButton
          type="link"
          onClick={() => handleDeletarLote(record, index)}
        >
          <DeleteOutlined />
        </ActionButton>
      )}
    </>
  );

  return <ContainerButtons>{content}</ContainerButtons>;
};

const custoFrete = (valorPj, valorPf) => {
  if (valorPj === valorPf && valorPj !== 0 && valorPf !== 0) {
    return <SubTitle>{formatarMoedaIMask(valorPj)}</SubTitle>;
  }
  if (valorPj === valorPf && valorPj === 0 && valorPf === 0) {
    return <SubTitle> </SubTitle>;
  }

  if (valorPj && valorPf === 0) {
    return (
      <>
        <SubTitle>{`${formatarMoedaIMask(valorPj)}`}</SubTitle>
      </>
    );
  }

  return (
    <>
      <SubTitle>
        {`${formatarMoedaIMask(valorPj)} / ${formatarMoedaIMask(valorPf)}`}
      </SubTitle>
    </>
  );
};

const custoFreteTransportadora = valorFrete => (
  <>
    <SubTitle>{`${formatarMoedaIMask(valorFrete)}`}</SubTitle>
  </>
);

const formatarPeriodo = (dataInicio, dataFim) => {
  if (!dataFim) {
    return (
      <SubTitle>{`${moment(dataInicio).format('DD/MM/YYYY')} - n/a `}</SubTitle>
    );
  }
  return (
    <>
      <SubTitle>
        {`${moment(dataInicio).format('DD/MM/YYYY')} - ${moment(dataFim).format(
          'DD/MM/YYYY'
        )}`}
      </SubTitle>
    </>
  );
};

const renderFormatoMilhar = valor => (
  <SubTitle>{`${formatarMilhar(valor)} t`}</SubTitle>
);

export const getColumns = (handleEditarLote, handleDeletarLote) => {
  // colunas da tabela
  const columns = [
    {
      title: 'Direcionamento',
      dataIndex: 'tipoDirecionamento',
      key: 'tipoDirecionamento',
      width: '20%',
      render: (text, record) => {
        const color =
          record.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE
            ? colors.$brandcolor_primary_dark_green
            : colors.$auxiliary_sky_2;

        return (
          <DirecionamentoWrapper>
            <Tag color={color} key={record.tipoDirecionamento}>
              {record.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE
                ? 'M'
                : ' T '}
            </Tag>
            &nbsp; &nbsp;
            {record.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE &&
              record.direcionamento === DirecionamentoEnum.PUBLICO && (
                <SubTitle style={{ display: 'contents' }}>Público</SubTitle>
              )}
            {record.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE &&
              record.direcionamento === DirecionamentoEnum.FROTISTA && (
                <SubTitle style={{ display: 'contents' }}>
                  {`${record.nomeFantasiaProprietario}`}
                </SubTitle>
              )}
            {record.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE &&
              record.direcionamento === DirecionamentoEnum.GRUPO_FROTISTA && (
                <SubTitle style={{ display: 'contents' }}>
                  {`${record.nomeGrupoFrotista}`}
                </SubTitle>
              )}
            {record.tipoDirecionamento ===
              TipoDirecionamentoEnum.TRANSPORTADORA && (
              <SubTitle style={{ display: 'contents' }}>
                {`${record.razaoSocialTransportadora}`}
              </SubTitle>
            )}
          </DirecionamentoWrapper>
        );
      },
    },
    {
      title: 'Volume (t)',
      dataIndex: 'volume',
      key: 'volume',
      width: '10%',
      align: 'center',
      render: volume => renderFormatoMilhar(volume),
    },
    {
      title: 'Cadência (t)',
      dataIndex: 'cadencia',
      key: 'cadencia',
      width: '10%',
      align: 'center',
      render: cadencia => renderFormatoMilhar(cadencia),
    },
    {
      title: 'Período',
      dataIndex: 'dataInicio',
      key: 'dataInicio',
      width: '15%',
      align: 'center',
      render: (_, record) =>
        formatarPeriodo(record.dataInicio, record?.dataFim),
    },
    {
      title: 'Frete Empresa (PJ/PF)',
      dataIndex: 'freteEmpresaPF',
      key: 'freteEmpresaPjPf',
      width: '15%',
      align: 'center',
      render: (_, record) => (
        <>
          {record.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE &&
            custoFrete(
              record?.freteEmpresaPj
                ? record?.freteEmpresaPj
                : record?.freteTotalPj,
              record?.freteEmpresaPf
                ? record?.freteEmpresaPf
                : record?.freteTotalPf
            )}
          {record.tipoDirecionamento ===
            TipoDirecionamentoEnum.TRANSPORTADORA &&
            custoFreteTransportadora(record?.freteEmpresaShipper)}
        </>
      ),
    },
    {
      title: 'Frete Motorista (PJ/PF)',
      dataIndex: 'freteMotoristaPF',
      key: 'freteMotoristaPjPf',
      width: '20%',
      align: 'center',
      render: (_, record) => (
        <>
          {record.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE &&
            custoFrete(record.freteMotoristaPj, record.freteMotoristaPf)}
          {record.tipoDirecionamento ===
            TipoDirecionamentoEnum.TRANSPORTADORA && '-'}
        </>
      ),
    },
    {
      title: 'Ações',
      width: '10%',
      align: 'center',
      render: (text, record, index) =>
        handleActions(record, handleEditarLote, handleDeletarLote, index),
    },
  ];

  return columns;
};
